import React, { Component } from 'react'

class browserSupportScreen extends Component {
  /*constructor(props) {
    super(props);
  }*/

  render() {
      return (
        <div className="animated fadeIn" style={{"overflow": "hidden"}}>
          <div className="row">
            <div className="col-md-12">
              <div className="card" style={{"background": "#e4e5e6", "border": "none"}}>
                <div className="card-body">
                  <div className="h-80vh-c flex-row align-items-center">
                    <div className="row justify-content-center" style={{"background": "#fff", "padding": "2rem"}}>
                      <div className="col-md-12" style={{"flex" : "0 0 auto"}}>
                        <div className="clearfix">
                          <h3 className="pt-3">Sorry, Microsoft Explorer is not supported.</h3>
                          <p>below is the browser that we support, please use latest version of</p>
                          <ul>
                            <li><a href="https://www.google.com/chrome/">Chrome</a></li>
                            <li><a href="https://www.apple.com/id/safari/">Safari (Mac OS only)</a></li>
                            <li><a href="https://www.mozilla.org/id/firefox/new/">Firefox</a></li>
                            <li><a href="https://www.opera.com/download">Opera</a></li>
                            <li><a href="https://www.microsoft.com/en-us/windows/microsoft-edge">Edge</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
  }

}

export default browserSupportScreen;



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/page/browserSupport.js